import docCookies from 'cookies-js';

export const root = state => state.getIn(['session']);
export const token = () => docCookies.get('BEARER');
export const authenticated = state => !!token() && root(state).get('isLoggedIn');
export const initialized = state => root(state).get('initialized');
export const currentUserId = state => root(state).get('currentUserId');
export const email = state => root(state).get('email');
export const oauthUri = state => root(state).get('oauthUri');
